const pathToIgnore = new Set(["/profilo", "/notifiche"]);

// Rotte di dettaglio (drill-down) non presenti nel menu ma accessibili agli
// utenti autenticati: dashboard dettaglio impianto e analisi tracker.
const prefixToIgnore = ["/impianti/"];

export default defineNuxtRouteMiddleware((to, from) => {
  const env = useRuntimeConfig();
  const BASE_PROGETTO = env.public.base_progetto;
  const isAuthenticated = useCookie(`token${BASE_PROGETTO}`).value;
  const pagePath = to.path.replace(/\/$/, "");

  if (!isAuthenticated) {
    if (pagePath === "/login") {
      return;
    }
    return navigateTo("/login");
  }

  // Se sei loggato vai direttamente in dashboard
  if (pagePath === "/login") {
    return navigateTo("/dashboard");
  }

  if (pathToIgnore.has(pagePath)) {
    return;
  }

  // Catalogo del design system: solo in sviluppo (in produzione le pagine /dev non esistono)
  if (false && eRottaDiSviluppo(pagePath)) {
    return;
  }

  if (prefixToIgnore.some((p) => pagePath.startsWith(p))) {
    return;
  }

  // Il menu del ruolo (store `auth`): senza ruolo noto (primo avvio dopo l'aggiornamento) la guardia non decide, ci pensa il server
  const menu = useAuthStore().menu;

  if (menu.length === 0) {
    return;
  }

  const findRoute = (items, path) => {
    for (const item of items) {
      if (item.route === path) {
        return item;
      }
      if (item.items) {
        const found = findRoute(item.items, path);
        if (found) {
          return found;
        }
      }
    }
    return null;
  };

  const routeFound = findRoute(menu, pagePath);
  if (!routeFound) {
    return navigateTo("/login");
  }
});
